(() => {
  if (window.__resoShopPayTrackingInitialized) return;
  window.__resoShopPayTrackingInitialized = true;

  const eventName = 'reso:buy_with_shop_clicked';
  const dedupeWindow = 3000;
  let lastTrackedAt = 0;

  const getShopPayButton = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

    return path.find(
      (element) => element instanceof Element && element.matches('shop-pay-wallet-button')
    );
  };

  const publishShopPayClick = (shopPayButton) => {
    const now = Date.now();
    if (now - lastTrackedAt < dedupeWindow) return;

    const form = shopPayButton.closest('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]');
    const quantityInput = form?.querySelector('[name="quantity"]');
    const priceElement = form?.querySelector('product-buy-price[data-price]');
    const priceInCents = Number(priceElement?.dataset.price || form?.dataset.productPrice || 0);
    const quantity = Number(quantityInput?.value || 1);
    const eventData = {
      source: 'buy_with_shop',
      product_id: form?.dataset.productId || '',
      product_title: form?.dataset.productTitle || '',
      variant_id: variantInput?.value || '',
      currency: form?.dataset.currency || '',
      value: priceInCents > 0 ? (priceInCents * quantity) / 100 : 0,
      quantity,
      page_url: window.location.href
    };

    if (window.Shopify?.analytics?.publish) {
      lastTrackedAt = now;
      window.Shopify.analytics.publish(eventName, eventData);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const shopPayButton = getShopPayButton(event);
      if (shopPayButton) publishShopPayClick(shopPayButton);
    },
    true
  );
})();
